import { createClickRewardApiStore } from '@/api'
import { downloadFile, getFilenameFromContentDisposition } from '@/utils/FileUtils'

const getInitialPageParams = () => ({
  pageNumber: 1,
  pageCount: 30,
})

const apiStore = createClickRewardApiStore([
  {
    action: '_campaignReportList',
    path: `partners/{partnerNo}/campaigns/reports`,
    pathParams: ['partnerNo'],
    method: 'get',
    cacheable: false,
  },
])

export default {
  namespaced: true,

  mixins: [apiStore],

  state: {
    pageParams: getInitialPageParams(),

    searchParams: {},

    searchResult: {
      list: [],
      total: 0,
    },
  },

  actions: {
    async getCampaignReportList({ dispatch, getters, commit, rootGetters }) {
      const params = {
        ...getters.currentParams,
        partnerNo: rootGetters['authentication/partnerNo'],
      }

      const response = await dispatch('_campaignReportList', {
        params,
      })

      commit('SET_SEARCH_RESULT', response.data)
    },
  },

  mutations: {
    SET_SEARCH_PARAMS(state, newSearchParams) {
      state.searchParams = newSearchParams
    },

    SET_PAGE_PARAMS(state, newPageParams) {
      state.pageParams = {
        ...state.pageParams,
        ...newPageParams,
      }
    },

    RESET_PAGE_PARAMS(state) {
      state.pageParams = getInitialPageParams()
    },

    SET_SEARCH_RESULT(state, data) {
      state.searchResult = {
        list: data.metrics,
        total: data.info.total,
      }
    },

    SET_TOTAL(state, total = 0) {
      state.total = total
    },
  },

  getters: {
    currentParams(state) {
      return {
        ...state.searchParams,
        ...state.pageParams,
      }
    },
  },
}
